export default __webpack_public_path__ + "static/media/ic_chevron_left.1b7e7d87.svg";